import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';

export class InvoiceDetailsSpecification extends React.Component {

  static propTypes = {
    invoice: PropTypes.object
  };

  render () {
    let invoice = this.props.invoice;
    if (invoice) {
      return (<div className='invoice-details-part-container'>
        <Translate className='invoice-details-title' content='INVOICE_DETAILS_SPECIFICATION' />
        <div className='invoice-details-border-container'>{invoice.specification}</div>
      </div>);
    }
    return null;
  }
}

export default InvoiceDetailsSpecification;



/** WEBPACK FOOTER **
 ** ./src/components/invoice-details/specification.js
 **/